import React from 'react';
import PropTypes from "prop-types";

const ModalDeleteCourse = ({ hideModalDelete, showModalDeleteCourse, removeCourseConfirmation, courseId, courseName}) => {
    return(
        <div
            className={`bootbox modal fade bootbox-confirm ${showModalDeleteCourse && "in"}`}
            tabIndex="-1"
            role="dialog"
            style={{
                display: showModalDeleteCourse ? "block": "none",
                paddingRight: 15
            }}
        >
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            style={{marginTop: -10}}
                            onClick={() => hideModalDelete()}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <div className="sp-10 font-16">
                                Do you really want to remove the course "{courseName}"?<br /><br />
                                This will also delete all subjects, chapters, lectures, and other content related to this course.  This action is irreversable, which is why we're asking you to confirm your action.
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            data-bb-handler="cancel"
                            type="button"
                            className="btn btn-default"
                            onClick={() => hideModalDelete()}
                        >
                            CANCEL
                        </button>
                        <button
                            data-bb-handler="confirm"
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                                {
                                    hideModalDelete();
                                    removeCourseConfirmation(courseId);
                                }
                            }
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModalDeleteCourse.propTypes = {
    showModalDeleteCourse: PropTypes.bool.isRequired,
    hideModalDelete: PropTypes.func.isRequired,
    removeCourseConfirmation: PropTypes.func.isRequired,
    courseId: PropTypes.any.isRequired
};

export default ModalDeleteCourse;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ModalDeleteCourse.js